import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = { class: "d-flex align-center justify-space-between mb-1" }
const _hoisted_3 = { class: "text-subtitle-1 font-weight-medium" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "d-flex flex-wrap" }

import { computed, onMounted, ref, watch } from 'vue';
import { useRolesStore } from '@/store/roles';


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionsDialog',
  props: {
    role: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const rolesStore = useRolesStore();
const open = ref(true);
const saving = ref(false);

const q = ref('');
const selected = ref<string[]>([]);

onMounted(async () => {
  // cargar permisos si no están
  if (!rolesStore.permissions?.length) {
    await rolesStore.fetchPermissions();
  }
  // permisos actuales del rol (si viene con include=permissions)
  selected.value = (props.role?.permissions || []).map((p: any) => p.name);
});

watch(() => props.role, (r) => {
  selected.value = (r?.permissions || []).map((p: any) => p.name);
});

const grouped = computed(() => {
  const groups: Record<string, { category: string; permissions: any[] }> = {};
  for (const p of rolesStore.permissions) {
    const cat = p.category || 'General';
    if (!groups[cat]) groups[cat] = { category: cat, permissions: [] };
    groups[cat].permissions.push(p);
  }
  // a array
  return Object.values(groups).sort((a, b) => a.category.localeCompare(b.category));
});

const filtered = computed(() => {
  const term = q.value.trim().toLowerCase();
  if (!term) return grouped.value;
  return grouped.value
    .map(g => ({
      category: g.category,
      permissions: g.permissions.filter((p:any) =>
        p.label?.toLowerCase().includes(term) ||
        p.name?.toLowerCase().includes(term) ||
        g.category?.toLowerCase().includes(term)
      )
    }))
    .filter(g => g.permissions.length);
});

function isSelected(name: string) {
  return selected.value.includes(name);
}
function toggle(name: string) {
  if (isSelected(name)) {
    selected.value = selected.value.filter(n => n !== name);
  } else {
    selected.value = [...selected.value, name];
  }
}
function selectAll(perms: any[]) {
  const names = perms.map(p => p.name);
  const set = new Set([...selected.value, ...names]);
  selected.value = Array.from(set);
}
function clear(perms: any[]) {
  const names = perms.map(p => p.name);
  selected.value = selected.value.filter(n => !names.includes(n));
}

async function save() {
  if (!props.role?.id) return;
  try {
    saving.value = true;
    await rolesStore.syncRolePermissions(props.role.id, selected.value);
    emit('close');
  } finally {
    saving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: open.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
    width: "880",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-arrow-left")
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_1, "Permisos rol “" + _toDisplayString(_ctx.role?.name) + "”", 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  loading: saving.value,
                  onClick: save
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Guardar")
                  ])),
                  _: 1,
                  __: [4]
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: q.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((q).value = $event)),
                density: "compact",
                variant: "solo-filled",
                "prepend-inner-icon": "mdi-magnify",
                label: "Buscar permisos o categorías",
                class: "mb-3"
              }, null, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (group, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "py-3",
                  style: {"border-bottom":"1px solid rgba(0,0,0,.08)"}
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(group.category), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_btn, {
                        size: "x-small",
                        variant: "text",
                        onClick: ($event: any) => (selectAll(group.permissions))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Seleccionar todo")
                        ])),
                        _: 2,
                        __: [5]
                      }, 1032, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        size: "x-small",
                        variant: "text",
                        onClick: ($event: any) => (clear(group.permissions))
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Limpiar")
                        ])),
                        _: 2,
                        __: [6]
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (perm) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: perm.name,
                        class: "ma-1",
                        variant: isSelected(perm.name) ? 'elevated' : 'outlined',
                        onClick: ($event: any) => (toggle(perm.name)),
                        label: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(perm.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["variant", "onClick"]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})